// extracted by mini-css-extract-plugin
module.exports = {"item":"Post_item__3py1h","appWrapperContent":"Post_appWrapperContent__22S-F","myPost":"Post_myPost__2R1dd","imgMiniAvatar":"Post_imgMiniAvatar__2UnsR"};